module.exports = __webpack_public_path__ + "img/img-business2.ffd9ab52.png";